import { useEffect } from 'react';
import { prop, isEmpty, pick } from 'ramda';
import { useParams } from 'react-router-dom';
import { useAppSelector, useCookieSettingsSelector } from 'js/store/hooks';

import * as helpers from '../helpers';

export const useRemoveCookies = () => {
    const { pathLang } = useParams();
    const { groupsData, removeCookiesInterval } = useCookieSettingsSelector(pick(['groupsData', 'removeCookiesInterval']));
    const { cookieGroups, enableCookiesAdmission } = useAppSelector(prop('cookiesConfiguration'));

    useEffect(() => {
        if (!enableCookiesAdmission || isEmpty(groupsData)) {
            return;
        }

        const cookiesData = helpers.getCookiesList(cookieGroups, groupsData);

        if (!cookiesData.length) {
            return;
        }

        helpers.clearCookies(cookiesData, pathLang);

        const intervalId = setInterval(() => {
            helpers.clearCookies(cookiesData, pathLang);
        }, removeCookiesInterval);

        return () => clearInterval(intervalId);
    }, [groupsData, cookieGroups, enableCookiesAdmission, removeCookiesInterval, pathLang]);
};
